import React from 'react';

import { Circle, Rectangle, SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

/**
 * Skeleton loader for a single group recommendation card.
 * Displays placeholder shapes matching the structure of a group recommendation.
 *
 * ```tsx
 * <GroupRecommendationSkeleton />
 * ```
 */
export const GroupRecommendationSkeleton: React.FC<EmptyProps> = () => {
	return (
		<div className="shadow-card flex w-40 flex-col items-start rounded-xl border border-stroke-secondary bg-surface-primary">
			<SkeletonContainer loading className="flex w-full flex-col">
				<Rectangle className="h-32 w-full" />
				<div className="flex flex-col items-start gap-3 p-4">
					<div className="flex flex-col items-start gap-1 self-stretch">
						<div className="flex flex-col items-start gap-1">
							<Rectangle rounded className="h-5 w-24" />
							<Rectangle rounded className="h-5 w-32" />
						</div>
						<div className="flex flex-col items-start gap-2.5 py-0.5">
							<Rectangle rounded className="h-4 w-28" />
						</div>
					</div>
					<div className="inline-flex items-center gap-2">
						<Circle className="h-4 w-4" />
						<Rectangle rounded className="h-3 w-16" />
					</div>
				</div>
			</SkeletonContainer>
		</div>
	);
};
